import React from "react"
import PropTypes from "prop-types"
import { IconButton } from "@kit/design/button"
import mount from "core/mount"

const BackBtn = ({ label, href }) => {
  return (
    <IconButton
      icon="arrow-left"
      label={label}
      href={href}
      className="rounded border border-solid border-transparent mr-2 md:my-3 hover:bg-gray-50 focus:outline-blue focus:bg-gray-50"
      style={{ padding: 7 }}
    />
  )
}

BackBtn.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string
}

mount({ BackBtn })
export default BackBtn
